(function () {
  "use strict";
  var storageKey = "ms-trends-shopify-favorites-v1";
  var saved = [];
  var activeHome = null;
  try {
    var stored = JSON.parse(localStorage.getItem(storageKey) || "[]");
    if (Array.isArray(stored)) saved = stored.filter(function (id) { return typeof id === "string"; });
  } catch (_) {}
  function all(root, selector) { return Array.prototype.slice.call(root.querySelectorAll(selector)); }
  function refreshSaved() {
    all(document, "[data-ms-saved-count]").forEach(function (count) {
      count.textContent = String(saved.length);
      count.hidden = saved.length === 0;
    });
    all(document, "[data-ms-saved]").forEach(function (button) {
      button.hidden = false;
      button.setAttribute("aria-label", "View saved favorites (" + saved.length + ")");
    });
    all(document, "[data-ms-save]").forEach(function (button) {
      var selected = saved.indexOf(button.dataset.msSave) !== -1;
      var card = button.closest("[data-ms-card]");
      button.hidden = false;
      button.setAttribute("aria-pressed", String(selected));
      button.setAttribute("aria-label", (selected ? "Remove " : "Save ") + card.dataset.title + (selected ? " from" : " to") + " favorites");
    });
  }
  function initHeader(root) {
    all(root, "[data-ms-header]").forEach(function (header) {
      if (header.dataset.msReady) return;
      header.dataset.msReady = "true";
      var menu = header.querySelector("[data-ms-menu]");
      var toggle = header.querySelector("[data-ms-menu-toggle]");
      function closeMenu() {
        menu.hidden = true;
        toggle.setAttribute("aria-expanded", "false");
        toggle.setAttribute("aria-label", "Open menu");
      }
      toggle.addEventListener("click", function () {
        var opening = menu.hidden;
        menu.hidden = !opening;
        toggle.setAttribute("aria-expanded", String(opening));
        toggle.setAttribute("aria-label", opening ? "Close menu" : "Open menu");
      });
      all(menu, "a").forEach(function (link) { link.addEventListener("click", closeMenu); });
      document.addEventListener("keydown", function (event) {
        if (event.key === "Escape" && !menu.hidden) { closeMenu(); toggle.focus(); }
      });
      window.addEventListener("resize", function () { if (window.innerWidth > 760) closeMenu(); });
      header.querySelector("[data-ms-saved]").addEventListener("click", function () {
        if (activeHome && activeHome.isConnected) {
          activeHome.msShowSaved();
        } else {
          var url = new URL(header.dataset.home, window.location.origin);
          url.searchParams.set("favorites", "1");
          url.hash = "edit";
          window.location.assign(url.toString());
        }
      });
    });
  }
  function initHome(root) {
    all(root, "[data-ms-boutique]").forEach(function (home) {
      if (home.dataset.msReady) return;
      home.dataset.msReady = "true";
      activeHome = home;
      var filter = "all";
      var query = "";
      var cards = all(home, "[data-ms-card]");
      var search = home.querySelector("[data-ms-search]");
      var buttons = all(home, "[data-filter]");
      function render() {
        var count = 0;
        cards.forEach(function (card) {
          var categoryMatches = filter === "all" || (filter === "saved" ? saved.indexOf(card.dataset.productId) !== -1 : card.dataset.category === filter);
          var searchMatches = (card.dataset.title + " " + card.dataset.category).toLowerCase().indexOf(query.trim().toLowerCase()) !== -1;
          var visible = categoryMatches && searchMatches;
          var wrapper = card.closest(".ms-card-wrapper") || card;
          wrapper.hidden = !visible;
          if (visible) count += 1;
        });
        buttons.forEach(function (button) {
          var selected = button.dataset.filter === filter;
          button.setAttribute("aria-pressed", String(selected));
          button.classList.toggle("active", selected);
        });
        home.querySelector("[data-ms-results]").textContent = count + (count === 1 ? " lovely find" : " lovely finds") + (filter === "saved" ? " saved for you" : " to explore");
        home.querySelector("[data-ms-empty]").hidden = count > 0;
        home.querySelector("[data-ms-empty-title]").textContent = filter === "saved" && !query ? "Your next favorites are waiting." : "A fresh start?";
        home.querySelector("[data-ms-empty-description]").textContent = filter === "saved" && !query ? "Tap the heart on a featured piece to keep it here on this device." : "Try another search, or explore all our finds.";
        refreshSaved();
      }
      home.msRefresh = render;
      home.msShowSaved = function () {
        filter = "saved";
        query = "";
        search.value = "";
        render();
        home.querySelector("#edit").scrollIntoView({block: "start"});
        home.querySelector('[data-filter="saved"]').focus({preventScroll: true});
      };
      buttons.forEach(function (button) {
        button.addEventListener("click", function () { filter = button.dataset.filter; render(); });
      });
      search.addEventListener("input", function () { query = search.value; render(); });
      home.querySelector("[data-ms-reset]").addEventListener("click", function () {
        filter = "all"; query = ""; search.value = ""; render(); search.focus({preventScroll: true});
      });
      home.addEventListener("click", function (event) {
        var button = event.target.closest("[data-ms-save]");
        if (!button) return;
        var id = button.dataset.msSave;
        var exists = saved.indexOf(id) !== -1;
        saved = exists ? saved.filter(function (value) { return value !== id; }) : saved.concat(id);
        var persisted = true;
        try { localStorage.setItem(storageKey, JSON.stringify(saved)); } catch (_) { persisted = false; }
        render();
        home.querySelector("[data-ms-status]").textContent = exists ? "Removed from your favorites." : (persisted ? "Saved to your favorites on this device." : "Saved for this visit.");
        var wrapper = button.closest(".ms-card-wrapper") || button.closest("[data-ms-card]");
        if (wrapper.hidden) home.querySelector('[data-filter="saved"]').focus({preventScroll: true});
      });
      home.querySelector("[data-ms-toolbar]").hidden = false;
      if (new URLSearchParams(window.location.search).get("favorites") === "1") filter = "saved";
      render();
    });
  }
  function boot(root) { initHeader(root); initHome(root); refreshSaved(); }
  boot(document);
  document.addEventListener("shopify:section:load", function (event) { boot(event.target); });
  window.addEventListener("storage", function (event) {
    if (event.key !== storageKey) return;
    try {
      var value = JSON.parse(event.newValue || "[]");
      if (!Array.isArray(value)) return;
      saved = value.filter(function (id) { return typeof id === "string"; });
      refreshSaved();
      if (activeHome && activeHome.isConnected) activeHome.msRefresh();
    } catch (_) {}
  });
})();
